import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';

const useStickyMobileFooterStyles = makeStyles({ name: 'sticky-mobile-footer' })(theme => ({
  footer: {
    alignItems: 'center',
    background: '#fff',
    bottom: 0,
    boxShadow: 'inset 0px 1px 0px rgba(0, 0, 0, 0.12)',
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    padding: theme.spacing(2),
    position: 'fixed',
    right: 0,
    zIndex: 1000,
  },
  footerBase: {
    display: 'flex',
    gap: theme.spacing(2),
    width: '100%',
    '& button': {
      flex: 1,
    },
  },
  footerBorder: {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  },
  noBorder: {
    boxShadow: 'none'
  },
}));

export type StickyMobileFooterProps = {
  showTopBorder?: boolean;
  children: NonNullable<React.ReactNode>;
};

export const StickyMobileFooter: React.FC<StickyMobileFooterProps> = ({ children, showTopBorder = true }) => {
  const { classes, cx } = useStickyMobileFooterStyles();

  return (
    <Box className={cx(classes.footer, showTopBorder ? classes.footerBorder : classes.noBorder)}>
      <Box className={classes.footerBase}>
        {children}
      </Box>
    </Box>
  );
};
